import axios from '@/http'
import router from '@/router'
import store from '@/store'

const info = (callback) => {
  axios.get('/cydex/api/v1/server_info')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const logout = () => {
  localStorage.setItem('token', '')
  localStorage.setItem('completeNum', '0')
  localStorage.setItem('transferInfo', 'false')
  sessionStorage.setItem('autoLogin', 'false')
  router.push({ path: '/app/login' })
  axios.post('/cydex/api/v1/logout')
    .then(response => {
    })
}
const getAppVersion = (callback) => {
  // var hash = Math.random()
  // axios.get('/assets/assist/version.json?' + hash)
  // .then(response => {
  //   var back = {
  //     win32: {
  //       version: response.data.win32.version,
  //       downloadUrl: response.data.win32.downloadUrl
  //     },
  //     mac: {
  //       version: response.data.mac.version,
  //       downloadUrl: response.data.mac.downloadUrl
  //     }
  //   }
  //   callback(back)
  // })
}
const getDownloadUrl = (callback) => {
  var hash = Math.random()
  // axios.get('/assets/assist/version.json?' + hash)
  // axios.get('https://www.cydex.cn/enterprise/release/3.0/version.json?' + hash)
  axios.get('https://arkhub.catontechnology.com:9002/release/version.json?' + hash)
    .then(response => {
      if (localStorage.getItem('language') === 'zh-cn') {
        var iosDownloadUrl = response.data.ios.downloadUrl_cn
      } else {
        iosDownloadUrl = response.data.ios.downloadUrl_en
      }
      var back = {
        win32: response.data.win32.downloadUrl,
        mac: response.data.mac.downloadUrl,
        android: response.data.android.downloadUrl,
        ios: iosDownloadUrl
      }
      callback(back)
    })
}
const getUser = (callback) => {
  axios.get('/cydex/api/v1/user')
    .then(response => {
      // console.log(response)
      var back = {
        name: response.data.name,
        email: response.data.email,
        uid: response.data.id,
        imgUrl: response.data.pic_url,
        role: response.data.role,
        company_role: response.data.company_role
      }
      callback(back)
    })
}
const getUserRole = (projectId, callback) => {
  if (!projectId) {
    return
  }
  axios.get('/cydex/api/v1/projects/' + projectId + '/members/permissions')
    .then(response => {
      var back = {
        permission: response.data.permission,
        codes: response.data.permission_codes
      }
      store.dispatch('addPermission', back)
      callback(back)
    })
}
const getFilesId = (id, pageSize, pageNum, op, callback) => {
  axios.get('/cydex/api/v1/packages/' + id + '/files', {
    params: {
      'op': op,
      'page_size': pageSize,
      'page_num': pageNum
    }
  })
    .then(response => {
      if (response.data.total_num <= 200) {
        var back = response.data
        callback(back)
      } else {
        var back1 = response.data.files
        var listNum = response.data.total_num
        var num = Math.ceil(response.data.total_num / 200) - 1
        var allLength = listNum - 200
        getFilesIdMore(id, op, num, allLength)
          .then(response => {
            back = {
              total_num: listNum,
              files: back1.concat(response)
            }
            callback(back)
          })
      }
    })
}
const getFilesIdMore = (id, op, a, allLength) => {
  return new Promise((resolve, reject) => {
    var x = []
    for (var i = 0; i < a; i++) {
      (function (index) {
        getFilesIdMoreResponse(id, op, i, response => {
          x = x.concat(response)
          if (x.length === allLength) {
            resolve(x)
          }
        })
      })(i)
    }
  })
}
const getFilesIdMoreResponse = (id, op, a, callback) => {
  axios.get('/cydex/api/v1/packages/' + id + '/files', {
    params: {
      'op': op,
      'page_size': 200,
      'page_num': a + 2
    }
  })
    .then(response => {
      callback(response.data.files)
    })
}
const getZonesId = (callback) => {
  axios.get('/cydex/api/v1/zones')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getProject = (id, callback) => {
  axios.get('/cydex/api/v1/projects/' + id, { params: {
    'with_stat': 1
  } })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getProjectList = (type, callback) => {
  axios.get('/cydex/api/v1/projects/', { params: {
    'type': type
  } })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getUsersList = (id, callback) => {
  axios.get('/cydex/api/v1/projects/' + id + '/members')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const traffic = (type, id, startData, endData, callback) => {
  var timeZone = localStorage.getItem('timeZone')
  if (type === 'all') {
    axios.get('/cydex/api/v1/stat/root/daily', { params: {
      'dt_start': startData,
      'dt_end': endData,
      'time_zone': timeZone
    } })
      .then(response => {
        var back = response.data
        callback(back)
      })
  }
  if (type === 'project') {
    axios.get('/cydex/api/v1/stat/project/daily', { params: {
      'dt_start': startData,
      'dt_end': endData,
      'project_id': id,
      'time_zone': timeZone
    } })
      .then(response => {
        var back = response.data
        callback(back)
      })
  }
  if (type === 'user') {
    timeZone = localStorage.getItem('timeZone')
    axios.get('/cydex/api/v1/stat/root/daily', { params: {
      'dt_start': startData,
      'dt_end': endData,
      'root_user_id': id,
      'time_zone': timeZone
    } })
      .then(response => {
        var back = response.data
        callback(back)
      })
  }
}
const getNotice = (callback) => {
  axios.get('/cydex/api/v1/settings/events')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getCharge = (e, callback) => {
  axios.post('/pay/api/v1/create_charge', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getFlow = (e, callback) => {
  axios.get('/cydex/api/v1/user_quota', { params: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getOrder = (e, callback) => {
  axios.get('/pay/api/v1/order/' + e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getSharelist = (e, callback) => {
  axios.get('/cydex/api/v1/download_user_list', { params: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getDownloadFilesInfo = (e, callback) => {
  axios.get('cydex/api/v1/get_pkg_info_by_token', { params: {
    token: e
  } })
    .then(response => {
      var back = {
        err: 0,
        data: response.data
      }
      callback(back)
    })
    .catch(error => {
      if (error.response) {
        var back = {
          err: 1,
          data: error.response.data
        }
        callback(back)
      }
    })
}
const getRequestToSendInfo = (e, callback) => {
  axios.get('cydex/api/v1/get_request_info_by_token', { params: {
    token: e
  } })
    .then(response => {
      var back = {
        err: 0,
        data: response.data
      }
      callback(back)
    })
    .catch(error => {
      if (error.response) {
        var back = {
          err: 1,
          data: error.response.data
        }
        callback(back)
      }
    })
}
const getEmailUid = (e, callback) => {
  axios.post('cydex/api/v1/register_direct', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const setCode = (e) => {
  axios.post('cydex/api/v1/id_code', e)
  // .then(response => {
  //   var back = response.data
  //   callback(back)
  // })
}
const getPkgMore = (id, e, callback) => {
  axios.get('cydex/api/v1/packages/' + id, { params: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const requestToSend = (e, callback) => {
  axios.post('cydex/api/v1/request_to_send/', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getSettingsEmails = (callback) => {
  axios.get('cydex/api/v1/settings/default_notification/')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const setSettingsEmails = (e, callback) => {
  axios.put('cydex/api/v1/settings/default_notification/', {
    settings: {
      mail_list: e
    }
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const changeTimezone = (params, callback) => {
  axios.put('cydex/api/v1/language_timezone', {
    language: params.language,
    time_zone: params.time_zone,
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const ProjectInviteRecord = (
  id,
  pageNum,
  pageSize,
  callback
) => {
  axios.get('cydex/api/v1/projects/' + id + '/invite_record', {
    params: {
      page_num: pageNum,
      page_size: pageSize,
    }
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getRetrieveList = (params, callback) => {
  axios.get('cydex/api/v1/retrieve', {
    params: params,
    timeout: 10 * 1000
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const retrieveFile = (e, callback) => {
  axios.post('cydex/api/v1/retrieve', e, {
    timeout: 10 * 1000
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
export default
{
  info,
  logout,
  getAppVersion,
  getUser,
  getUserRole,
  getFilesId,
  getZonesId,
  getProject,
  getProjectList,
  getUsersList,
  traffic,
  getNotice,
  getDownloadUrl,
  getCharge,
  getFlow,
  getOrder,
  getDownloadFilesInfo,
  getEmailUid,
  setCode,
  getSharelist,
  getPkgMore,
  requestToSend,
  getRequestToSendInfo,
  getSettingsEmails,
  setSettingsEmails,
  changeTimezone,
  ProjectInviteRecord,
  getRetrieveList,
  retrieveFile
}
